import { render } from "./create-accessToken-modal.vue?vue&type=template&id=330228b0&scoped=true"
import script from "./create-accessToken-modal.vue?vue&type=script&lang=js"
export * from "./create-accessToken-modal.vue?vue&type=script&lang=js"

import "./create-accessToken-modal.vue?vue&type=style&index=0&id=330228b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-330228b0"]])

export default __exports__